import { Suspense, type ReactNode } from 'react';

/**
 * Suspense boundary for a lazily loaded admin screen.
 *
 * Its own module so `adminRoutes.tsx` exports only the route table — mixing component and
 * non-component exports in one file breaks fast refresh.
 */
export function LazyScreen({ children }: { readonly children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <main className="grid min-h-dvh place-items-center px-6">
          <p className="text-muted">Loading…</p>
        </main>
      }
    >
      {children}
    </Suspense>
  );
}
